const ROOT = '/';
const UPLOAD = `${ROOT}upload`;
const UPLOAD_MISSIONS = `${ROOT}upload-data`;
const AUTH = `${ROOT}auth`;
const SIGN_UP = `${ROOT}signup`;
const SIGN_UP_CONFIRM = `${ROOT}signup/account-confirm-email/:id`;
const ACCOUNT = `${ROOT}account`;
const MODELS = `${ROOT}models`;
const TERMS = `${ROOT}terms`;
const POLICY = `${ROOT}policy`;
const STONE_VALIDATION = `${ROOT}stone-validation/:id`;
const EDGE_UNITS = `${ROOT}edge-units`;
const FIELDS = `${ROOT}fields`;
const STONE_REVIEW = `${ROOT}review`;

const PASSWORD_ROOT = `${ROOT}password`;
const RESET_PASSWORD = `${PASSWORD_ROOT}/reset`;
const FORGOT_PASSWORD = `${PASSWORD_ROOT}/forgot`;
const CONFIRM_PASSWORD = `${PASSWORD_ROOT}/reset/confirm/:uid/:token`;

export const ROUTES = {
  ROOT,
  UPLOAD,
  UPLOAD_MISSIONS,
  AUTH,
  SIGN_UP,
  SIGN_UP_CONFIRM,
  ACCOUNT,
  MODELS,
  RESET_PASSWORD,
  FORGOT_PASSWORD,
  CONFIRM_PASSWORD,
  TERMS,
  POLICY,
  STONE_VALIDATION,
  EDGE_UNITS,
  FIELDS,
  STONE_REVIEW
};
